import { gql } from '@apollo/client';

export default gql`
  mutation createUser($email: String!, $password: String!, $locale: String) {
    createUser(input: { email: $email, password: $password, locale: $locale }) {
      success
    }
  }
`;
